import breakPoints from '!!sass-variable-loader!./../scssVariables/breakpoints.scss';

export default breakPoints;



// WEBPACK FOOTER //
// ./src/assets/styles/jsVariables/breakpoints.js